export default "__VITE_ASSET__MBnsAoqF__"